function getPayloadFromAction(action) {
  const { type, ...rest } = action;
  return rest;
}

export default getPayloadFromAction;
